import { RewardsIconSchema } from "@apps/rewards/schemas/RewardsIconSchema";
import { nullable, number, object, string } from "superstruct";

export const CustomerRewardsActivitySchema = object({
    id: number(),
    title: string(),
    icon: nullable(RewardsIconSchema),
});
